import { memo } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { ReactComponent as ErrorPlaceholder } from '../../../assets/images/error.svg';
import { APP_PAGES } from '../../../constants/pages';
import { useTranslations } from '../../../utility/useTranslations';

const useStyles = makeStyles(({ palette: { primary } }) => ({
  main: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  title: {
    color: primary.pink1,
  },
  description: {
    fontSize: 24,
  },
  errorPlaceholder: {
    maxHeight: 'calc(100vh - 334px)',
    width: 'auto',
  },
}));

const PublicJobUnavailable = () => {
  const translations = useTranslations(APP_PAGES.PUBLIC_JOB_UNAVAILABLE);
  const classes = useStyles();

  return (
    <div className={classes.main}>
      <Typography variant="h1" className={classes.title}>
        {translations.pageTitle}
      </Typography>
      <Typography className={classes.description}>
        {translations.description}
      </Typography>
      <ErrorPlaceholder className={classes.errorPlaceholder} />
    </div>
  );
};

export default memo(PublicJobUnavailable);
